<template>
    <header class="layout__header d-md-none primary-text position-relative" style="z-index: 1;">
        <logo></logo>
        <div id="mobile-nav">
            <button class="btn__icon primary-text"
                    aria-haspopup="dialog"
                    :aria-label="navLabel"
                    @click="open = true"
            >
                <span class="icon-menu icon__x2" aria-hidden="true"></span>
            </button>
            <app-nav :nav="nav"
                     :current="current"
                     :open="open"
                     :search="search"
                     :display-back="true"
                     @close="onClose()"
                     @next="onNext($event)"
                     @open-search="search = true"
                     @close-search="onClose()"
            ></app-nav>
        </div>
        <button class="btn__icon btn__icon--small primary-text"
                aria-haspopup="dialog"
                :aria-label="searchLabel"
                @click="onSearchClick()"
        >
            <span class="icon-search" aria-hidden="true"></span>
        </button>
    </header>
</template>

<script>
    import { getNavData } from './utils';
    import getSearchLabel from './search-label';
    import { isOnDanish } from '../utils/is-on-language';

    export default {
        data () {
            return {
                nav: getNavData(),
                navLabel: isOnDanish() ? 'Åbn webstedsnavigation' : 'Open website navigation',
                current: getNavData(),
                open: false,
                search: false,
                searchLabel: getSearchLabel(),
            };
        },
        methods: {
            onNext ($event) {
                this.current = $event;
                this.search  = false;
            },
            onClose() { 
                this.open = false; 
                this.search = false
            },
            onSearchClick () {
                this.search = true;
                this.open   = true;
            },
        },
    };
</script>
